import React from 'react'
import LeadTable from '../LeadTable'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import TodayTasks from '../../TodayTasks'

const ProjectHeadDashboard = ({projectId}) => {
  return (
    <div
      style={{
        fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
        color: "#0F1B2A",
        minWidth: 0,
      }}
    >
      {/* <LeadTable projectId={projectId}/> */}
      <TodayTasks />
    </div>
  )
}

export default ProjectHeadDashboard
